import app from 'srcJs/App';
import React, { useMemo } from 'react';
import { GTMProvider } from '@elgorditosalsero/react-gtm-hook';
import { useSelector } from 'react-redux';
import { REDUCER_GLOBAL_NAME } from 'moduleBase/constants';
import { GOOGLE_TAG_MANAGER_ID } from 'src/constants';

var GoogleTagManagerProvider = function GoogleTagManagerProvider(_ref) {
  var children = _ref.children;

  if (!app.getExternalApp().isEnableGoogleTagManager()) {
    return children;
  }

  var dataLayer = useSelector(function (state) {
    return state[REDUCER_GLOBAL_NAME].dataLayer;
  });
  var gtmParams = useMemo(function () {
    return {
      id: GOOGLE_TAG_MANAGER_ID,
      dataLayer: dataLayer
    };
  }, []);
  return /*#__PURE__*/React.createElement(GTMProvider, {
    state: gtmParams
  }, children);
};

export { GoogleTagManagerProvider };